import Purchase from "./Purchase";
import Payment from "./Payment";
import Confirmation from "./Confirmation";
import Completion from "./Completion";

export default { Purchase, Payment, Confirmation, Completion };



// WEBPACK FOOTER //
// ./src/containers/OrderAggregators/index.js